import React from 'react'

const TandConditions = () => {
  return (
    <div>TandConditions</div>
  )
}

export default TandConditions